// Application-wide configuration constants

// Set ENABLE_AUTO_REFRESH to false to disable all automatic polling
// This can be helpful during development
export const ENABLE_AUTO_REFRESH = true

// Refresh rate constants (in milliseconds)
export const REFRESH_RATES = {
  FAST: 1000,
  DEFAULT: 3000,
  MEDIUM: 5000,
  SLOW: 10000,
  _30_SEC: 30 * 1000,
  _1_MIN: 60 * 1000,
  _2_MIN: 2 * 60 * 1000,
  VERY_SLOW: 5 * 60 * 1000,
}

// Helper function to get refresh rate (returns null if disabled)
export const getRefreshRate = (rate = REFRESH_RATES.DEFAULT) => {
  return ENABLE_AUTO_REFRESH ? rate : null
}
